import * as Yup from 'yup';

export const subscriptionPlanSchema = (isFreePlan: boolean) =>
  Yup.object().shape({
    planName: Yup.string()
      .trim()
      .required('Plan name is required')
      .matches(
        /^(?!.*\s{2,})(?!.*\d)[A-Za-z ]+$/,
        'Numbers and repeated spaces are not allowed',
      )
      .max(20, 'Plan name should be less than 20 characters'),

    planType: Yup.string().required('Plan Type is required'),

    description: Yup.string().trim().required('Description is required'),

    price: isFreePlan
      ? Yup.number().notRequired()
      : Yup.number()
          .typeError('Price must be a number')
          .positive('Price must be greater than 0')
          .integer('Decimals are not allowed')
          .max(99999, 'Price cannot exceed 5 digits')
          .required('Price is required'),
    durationDays: isFreePlan
      ? Yup.number()
          .typeError('Value must be a number')
          .positive('Value must be greater than 0')
          .integer('Decimals are not allowed')
          .max(999999, 'Value cannot exceed 6 digits')
          .notRequired()
      : Yup.number().notRequired(),
    deliveries: Yup.number()
      .typeError('Deliveries must be a number')
      .positive('Deliveries must be greater than 0')
      .integer('Decimals are not allowed')
      .max(9999, 'Deliveries cannot exceed 5 digits')
      .required('Deliveries are required'),

    colorCode: Yup.string()
      .matches(/^#([0-9A-F]{3}){1,2}$/i, 'Color must be a valid hex code')
      .required('Color is required'),
  });
